const comment = {
	name: 'Kommentar | Kommentare',
	icon: 'fas fa-comment',
	fields: {},
}

export default comment
